var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ToolbarWithProps } from '../common/Toolbar';
import ArticleContent from './ArticleContent';
import VideoContent from './VideoContent';
import { Body } from '../root/PageRouter';
import { SignInButton } from '../sign-in/sign-in';
import { Tile, TileComment, TileHeader } from '../common/Tile';
import styled from 'styled-components';
var Center = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: 1;\n  display: flex;\n  justify-content: center;\n"], ["\n  flex: 1;\n  display: flex;\n  justify-content: center;\n"])));
export default function ContentDetailsPreview(props) {
    var isArticle = props.type === 'ARTICLE';
    var title = isArticle ? 'Article' : 'Video';
    return (_jsxs(_Fragment, { children: [_jsx(ToolbarWithProps, { children: title }, void 0),
            _jsxs(Body, { children: [isArticle ? (_jsx(ArticleContent, { title: props.title, description: props.description, url: props.url }, void 0)) : (_jsx(VideoContent, { contentId: props.contentId, title: props.title, description: props.description, url: props.url, onProgress: props.onProgress }, void 0)),
                    _jsxs(Tile, { children: [_jsx(TileHeader, { children: "See full video" }, void 0),
                            _jsx(TileComment, { children: "The video above is a preview of the full video. Sign in to see the full video." }, void 0),
                            _jsx(TileComment, { children: _jsx(Center, { children: _jsx(SignInButton, {}, void 0) }, void 0) }, void 0)] }, void 0)] }, void 0)] }, void 0));
}
var templateObject_1;
//# sourceMappingURL=ContentDetailsPreview.js.map